import { render, staticRenderFns } from "./HeaderRegister.vue?vue&type=template&id=7a438cb4"
import script from "./HeaderRegister.vue?vue&type=script&lang=js"
export * from "./HeaderRegister.vue?vue&type=script&lang=js"
import style0 from "./HeaderRegister.vue?vue&type=style&index=0&id=7a438cb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports